import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function GraphBox({content}) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      },
    },
  };
  
  const data = {
    labels: content.labels,
    datasets: [
      {
        data: content.values,
        backgroundColor: '#075699',
      }
    ],
  };

  return (
    <div className='total-box corner-radius p-3 me-3 mb-3'>
        <div className='graph'>
          <Bar options={options} data={data} />
        </div>
    </div>
  )
}
